<template>
  <div>
    <SectionContainer
      class="d-flex flex-column items-center"
      style="min-height: calc(100vh - 310px)"
    >
      <AppHead />
      <EntityReport
        v-if="showEntityReport"
        :level="currentReportLevel"
        :entity-details="entityDetails"
      />
      <template v-else>
        <ChapterCard
          class="pb-5"
          :chapter="selectedChapter"
          :hide-button="hideStartChapterButton"
          :is-section-open="isSectionOpen"
          @start="startChapter"
        />
        <SectionProgress
          v-if="currentChapter && currentSection"
          :current-section="currentSection"
          :chapter-display-order="selectedChapter.display_order"
          :sections="sections"
        />
        <SectionCard
          v-if="currentChapter && currentSection"
          :section="currentSection"
          :selected-theme="parseInt(selectedTheme)"
          @continue="continueToNextSection"
        />
      </template>
    </SectionContainer>
    <EvaluationDetails v-if="currentChapter && currentSection" class="pt-5" />
  </div>
</template>

<script>
const INDEX = 'display_order'
const SUMMARY = 'sommaire-intermediaire'
import App from '../Layouts/App'
import ChapterCard from '../Components/SurveyForm/ChapterCard.vue'
import SectionCard from '../Components/SurveyForm/SectionCard.vue'
import EntityReport from '../Components/SurveyForm/EntityReport.vue'
import SectionProgress from '../Components/SurveyForm/SectionProgress.vue'
import EvaluationDetails from '../Components/EvaluationDetails.vue'
export default {
  components: {
    ChapterCard,
    SectionCard,
    EntityReport,
    SectionProgress,
    EvaluationDetails,
  },
  layout: App,
  props: {
    surveyQuestions: {
      type: Array,
      required: true,
    },
    surveyLevel: {
      type: Object,
      default: () => {},
      validator(value) {
        if (Object.keys(value).length > 0) {
          return Array.from(Object.keys(value)).includes(
            'chapter',
            'section',
            'theme',
            'summary'
          )
        }
        return true
      },
    },
  },
  data() {
    return {
      hideStartChapterButton: false,
      currentSection: null,
      currentChapter: null,
      showEntityReport: false,
      userSurveyChapterIds: [
        ...Object.values(this.$page.props.survey.chapter_ids),
      ],
    }
  },
  computed: {
    entityDetails() {
      return {
        title: this.survey.name,
        isLastChapter: this.isLastChapter,
        content: this.sections,
      }
    },
    survey() {
      return this.$page.props.survey
    },
    chapters() {
      return this.surveyQuestions.reduce((map, chapter) => {
        chapter.selected = false
        if (this.userSurveyChapterIds.includes(chapter.id)) {
          chapter.selected = true
        }
        return map.set(chapter[INDEX], chapter)
      }, new Map())
    },
    firstChapter() {
      return this.chapters.values().next().value
    },
    selectedChapter() {
      return this.surveyLevel.chapter
        ? this.getChapter(parseInt(this.surveyLevel.chapter))
        : this.firstChapter
    },
    sections() {
      if (this.selectedChapter) {
        return this.selectedChapter.sections.reduce((map, section) => {
          return map.set(section[INDEX], section)
        }, new Map())
      }
      return new Map()
    },
    firstChapterSection() {
      if (this.sections.size !== 0) {
        return this.sections.values().next().value
      }
      return {}
    },
    lastSection() {
      return Array.from(this.sections.values()).pop()
    },
    lastChapter() {
      return Array.from(this.selectedChapters.values()).pop()
    },
    selectedChapters() {
      return new Map(
        [...this.chapters].filter(([key, chapter]) => chapter.selected === true)
      )
    },
    isLastChapter() {
      if (this.selectedChapter) {
        return this.selectedChapter.id === this.lastChapter.id
      }
      return false
    },
    isLastSection() {
      if (this.currentSection) {
        return this.currentSection.id === this.lastSection.id
      }
      return false
    },
    currentReportLevel() {
      return this.isLastSection ?? !this.isLastChapter ? 'section' : 'chapter'
    },
    selectedTheme() {
      return this.surveyLevel.theme ?? 1
    },
    isSectionOpen() {
      return this.currentChapter && this.currentSection ? true : false
    },
  },
  created() {
    if (this.surveyLevel.chapter && this.surveyLevel.section) {
      const sectionLevel = this.surveyLevel.section
      this.startChapter(parseInt(sectionLevel))
    }
    if (this.surveyLevel.summary == SUMMARY) {
      this.showEntityReport = true
    }
  },
  methods: {
    getChapter(displayOrder) {
      if (!this.chapters.has(displayOrder)) {
        console.warn('Non existing chapter: ' + displayOrder)
        return this.firstChapter
      }
      return this.chapters.get(displayOrder)
    },
    startChapter(value) {
      this.currentChapter = this.selectedChapter
      this.hideStartChapterButton = true
      this.setSection(value)
    },

    setSection(displayOrder) {
      if (!this.sections.has(displayOrder)) {
        console.warn('Non existing section: ' + displayOrder)
        this.currentSection = this.firstChapterSection
        return
      }
      this.currentSection = this.sections.get(displayOrder)
    },
    continueToNextSection() {
      if (!this.isLastSection) {
        const currentIndex = this.currentSection[INDEX]
        return this.goNextSection(this.sections.get(currentIndex + 1))
      }
      return this.gotToSectionReport()
    },
    gotToSectionReport() {
      return this.goToEntitySummary()
    },
    goToEntitySummary() {
      return this.$inertia.visit(
        this.$route('survey.user.show', {
          id: this.survey.id,
        }),
        {
          data: {
            chapitre: this.currentChapter.display_order,
            etape: SUMMARY,
          },
          preserveScroll: false,
          replace: false,
        }
      )
    },
    goNextSection(nextSection) {
      return this.$inertia.visit(
        this.$route('survey.user.show', {
          id: this.survey.id,
        }),
        {
          data: {
            chapitre: this.currentChapter.display_order,
            section: nextSection.display_order,
          },
          preserveScroll: false,
          replace: false,
        }
      )
    },
  },
}
</script>
<style scoped>
h2 {
  font-style: normal;
  font-weight: 400;
  line-height: 1.4em;
  font-size: 1.4rem;
  letter-spacing: 0.108em;
}
</style>
